export enum TextFilterTypes {
  contains = 'Contains',
  equals = 'Equals',
  notEqual = 'Not equal',
  startsWith = 'Starts with',
  endsWith = 'Ends with',
}
